import superagent from 'superagent'

import {
  HttpMethods,
  NetworkHandler,
  NetworkInterface,
  NetworkOptions,
  ResponseBody,
  ResponseHeaders,
  ResponseStatus,
  ResponseText,
  Url,
} from './types'

const createRequest = (url: Url, method: HttpMethods, body: any) => {
  const methodHandler = (superagent as any)[String(method).toLowerCase()]
  if (!methodHandler) {
    throw new Error(`Unsupported HTTP method: ${method}`)
  } else {
    return methodHandler(url, body)
  }
}

const getReponseTypeByAccept = (accept?: string) => {
  switch (accept) {
    case 'text/csv':
      return 'blob'
  }
}

const getReponseTypeByContentType = (contentType?: string) => {
  switch (contentType) {
    case 'application/pdf':
    case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
      return 'blob'
  }
}

const getResponseType = (contentType?: string, accept?: string) =>
  getReponseTypeByContentType(contentType) || getReponseTypeByAccept(accept)

type ExecuteCallback = (
  error: any,
  status: ResponseStatus,
  responseBody?: ResponseBody,
  responseText?: ResponseText,
  responseHeaders?: ResponseHeaders,
) => void

export const superagentNetworkInterface: NetworkInterface = (
  url: Url,
  method: HttpMethods,
  {body, headers, credentials}: NetworkOptions = {},
): NetworkHandler => {
  const request = createRequest(url, method, body)

  if (headers) {
    request.set(headers)
  }

  if (credentials === 'include') {
    request.withCredentials()
  }

  const responseType = getResponseType(request.get('content-type'), request.get('accept'))

  if (responseType) {
    request.responseType(responseType)
  }

  const execute = (cb: ExecuteCallback) =>
    request.end((err: Error, response: Response) => {
      const resStatus = (response && response.status) || 0
      const resBody = (response && response.body) || undefined
      const resText = (response && (response.text as any)) || undefined
      const resHeaders = (response && (response.headers as any)) || undefined

      cb(err, resStatus, resBody, resText, resHeaders)
    })

  const abort = () => request.abort()

  return {
    abort,
    execute,
  }
}
